
import { Vue } from "vue-class-component";

export default class PublicLayout extends Vue {}
